const ButtonVisibilityToggle = ({ showElement, setShowElement, textVisible, textHidden }) => {
    return (
        <button
            className={`button button-slim ${showElement ? 'button-red' : 'button-blue'}`}
            onClick={() => setShowElement(!showElement)}
        >
            {showElement ? textVisible : textHidden}
        </button>
    )
}

export default ButtonVisibilityToggle